import React, { FunctionComponent } from 'react';
import { ShepherdIcon } from '@companion-professional/components';

interface PageFrameProps {
  children: React.ReactNode;
  // exportedAt is the ISO timestamp the share was created. The "Exported ... on <date>" line is omitted until it is
  // known (e.g. while loading or on an error screen).
  exportedAt?: string;
}

// formatExportedDate renders an ISO timestamp as a numeric date in the viewer's own locale and time zone.
const formatExportedDate = (exportedAt: string) =>
  new Date(exportedAt).toLocaleDateString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' });

// PageFrame is the shared shell for every screen: a branded Shepherd Lens header above a centered content area.
// Keeping it in one place means the loading, error, and player states all sit under the same branding.
export const PageFrame: FunctionComponent<PageFrameProps> = ({ children, exportedAt }) => (
  <div className="flex h-full w-full flex-col">
    <header className="flex w-full items-start gap-3 border-b-4 border-primary bg-widget px-6 py-5">
      <ShepherdIcon className="h-10" />
      <div className="flex flex-col">
        <h1 className="text-2xl font-bold leading-tight text-primary">Shepherd Lens Video</h1>
        {exportedAt && (
          <p className="text-base text-primary">
            Exported with Shepherd Veterinary Software on {formatExportedDate(exportedAt)}
          </p>
        )}
      </div>
    </header>
    <main className="flex w-full flex-1 flex-col items-center justify-center p-4">{children}</main>
  </div>
);
